import { motion } from 'framer-motion';
import {
  ClipboardCheck, ShieldCheck, FileSearch, Files, Scroll, Handshake,
} from 'lucide-react';

const STEPS = [
  { icon: ClipboardCheck, title: 'Complete free assessment', body: 'Answer 10 short questions. Takes under 3 minutes. Nothing to sign.', num: '01' },
  { icon: ShieldCheck, title: 'Attorney review', body: 'A South African attorney reviews your responses to identify potential grounds.', num: '02' },
  { icon: FileSearch, title: 'Case evaluation', body: 'If viable, we discuss the applicable law — the CPA, the Constitution, and leading authorities.', num: '03' },
  { icon: Files, title: 'Gather evidence', body: 'Police docket, warning statements, medical records, witnesses. We guide you through it.', num: '04' },
  { icon: Scroll, title: 'Claim instituted', body: 'Notice served in terms of the applicable Institution of Legal Proceedings legislation.', num: '05' },
  { icon: Handshake, title: 'Negotiation or litigation', body: 'Many matters resolve through settlement. Others proceed to trial. We prepare either way.', num: '06' },
];

export default function ProcessTimeline() {
  return (
    <section data-testid="process-timeline" className="relative py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-inter font-bold uppercase tracking-[0.28em] text-[#FFD400]">Chapter 02 — Our Process</div>
          <h2 className="mt-4 font-poppins font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]">
            How a wrongful arrest claim <span className="text-[#39A8FF]">actually works.</span>
          </h2>
          <p className="mt-5 font-inter text-white/70 text-base md:text-lg leading-relaxed">
            Transparent, sequential, and rooted in South African procedure. You are informed at every step.
          </p>
        </div>

        <div className="mt-16 md:mt-20 relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute left-0 right-0 top-14 h-px bg-gradient-to-r from-transparent via-[#39A8FF]/30 to-transparent" />
          <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 lg:gap-2">
            {STEPS.map((s, i) => (
              <motion.li
                key={s.num}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="relative"
                data-testid={`process-step-${i}`}
              >
                <div className="relative rounded-2xl border border-white/[0.06] bg-[#0d1826]/60 p-6 h-full hover:border-[#0A84FF]/50 transition-colors group">
                  {/* Node */}
                  <div className="absolute -top-3 left-6 lg:left-1/2 lg:-translate-x-1/2 h-6 w-6 rounded-full bg-[#0A84FF] shadow-[0_0_20px_rgba(10,132,255,0.6)] flex items-center justify-center">
                    <span className="text-[10px] font-poppins font-bold text-white">{i + 1}</span>
                  </div>
                  <s.icon className="mt-4 h-6 w-6 text-[#39A8FF] group-hover:text-[#FFD400] transition-colors" strokeWidth={1.6} />
                  <div className="mt-6 text-[10px] font-inter font-bold uppercase tracking-[0.24em] text-white/45">Step {s.num}</div>
                  <div className="mt-1.5 font-poppins font-semibold text-white text-[17px] leading-snug">{s.title}</div>
                  <div className="mt-3 font-inter text-white/60 text-[13.5px] leading-relaxed">{s.body}</div>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
